<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-19 16:54:00
-->
<template>
  <!-- 育苗 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div class="type-activite">饲料实时有效库存</div>
      </div>
      <div class="page-list">
        <!-- 搜索栏 -->
        <div class="page-search-content" ref="searchBox">
          <!-- 年份 -->
          <div class="page-big-box">
            <div class="page-search-item">
              <label>仓库\区域&nbsp;:</label>
              <el-select v-model="params.params.groupId" filterable placeholder="请选择仓库\区域">
                <el-option label="全部仓库\区域" value=""></el-option>
                <el-option v-for="item in groupList" :key="item.groupId" :label="item.groupName" :value="item.groupId">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>饲料&nbsp;:</label>
              <el-select v-model="params.params.fodderId" filterable placeholder="请选择饲料">
                <el-option label="全部饲料" value=""></el-option>
                <el-option v-for="item in fodderList" :key="item.fodderId" :label="item.fodderName"
                  :value="item.fodderId">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="page-search-btn">
            <div class="search-btn" @click="search">查询</div>
            <div class="reset-btn" @click="reset">重置</div>
            <!-- <div class="search-close-btn">
              <div
                @click="PageSearchClose"
                v-if="PageDisplay"
              >
                <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
              </div>
              <div
                @click="PageSearchOn"
                v-else
              >
                <span>展开</span><i class="iconfont icon-List-Collapse"></i>
              </div>
            </div> -->
          </div>
        </div>
        <!-- 内容 -->
        <div class="page-list-content">
          <!-- 列表 -->
          <div class="page-list-title">
            <div><i class="title-icon"></i>饲料实时有效库存-育苗</div>
            <div>单位: {{ orgName }}</div>
            <div class="page-list-btns">
              <el-dropdown style="margin-right: 20px;" @command="setFixedColumn">
                <span class="el-dropdown-link">
                  冻结列<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="y">冻结至"{{
                    fixedColumn.label
                  }}"列</el-dropdown-item>
                  <el-dropdown-item command="n">取消冻结</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <RouteTarget :pathName="'day-ym-feed-feeding'">
                <span class="switch-table">饲料投喂记录</span>
              </RouteTarget>
              <RouteTarget :pathName="'day-ym-feed-in-out'">
                <span class="switch-table">进出存</span>
              </RouteTarget>
              <span @click="exportTable">
                <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
              </span>
            </div>
          </div>
          <!-- 表格 -->
          <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%"
            :row-class-name="tableRowClassName" @header-click="handleClick">
            <el-table-column :fixed="fixedColumnList[0].fixed"
              :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''" prop="groupName" label="仓库\区域">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[1].fixed"
              :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''" prop="fodderName" label="饲料名称">
            </el-table-column>
            <el-table-column prop="spec" label="规格"> </el-table-column>
            <el-table-column prop="stockNumber" label="现存数量"> </el-table-column>
            <el-table-column prop="stockWeight" label="现存重量"> </el-table-column>
            <el-table-column prop="stockMoney" label="现存金额"> </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteTarget from "@/components/pc/route-target.vue";
import Page from "@/utils/methods/page";
import {
  searchMdtFodderDataGroupList,
  exportMdtFodderDataGroupList,
  getGroupConditions,
  getFodderConditions,
} from "./ym-feed-services";
export default {
  name: "day-ym-feed",
  components: {
    RouteTarget,
  },
  data() {
    return {
      PageDisplay: true, // 展开收起
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "fodderName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 10,
        orderBy: "desc",
        orderByName: "groupName",
        params: {
          orgId: "", // 顶级机构id
          groupId: "",
          fodderId: "",
        },
      },
      orgName: "",
      exportParams: {}, // 导出参数
      tableData: [],
      groupList: [],
      fodderList: [],
    };
  },
  computed: {},
  methods: {
    // 查询
    search() {
      this.getPageList();
    },
    // 重置
    reset() {
      this.params.params.groupId = "";
      this.params.params.fodderId = "";
      this.getPageList();
    },
    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.fodderName === "合计") {
        return "heji-row";
      }
    },
    // 分页
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      searchMdtFodderDataGroupList(this.params).then((res) => {
        if (res.code == "0000") {
          this.tableData = res.data.list;
          this.exportParams = JSON.parse(JSON.stringify(this.params.params));
        }
        loading.close();
      });
    },
    // 导出
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        this.exportParams.fileName = "育苗饲料实时有效库存";
        Page.exportDatas(exportMdtFodderDataGroupList(), this.exportParams);
      });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
    Page.pagesTableFixed(); // 表头固定
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.params.params.orgId = localStorage.getItem("orgId");
    this.orgName = localStorage.getItem("orgName");
    this.getPageList(); // 获取分页
    // 仓库
    getGroupConditions({ orgId: this.params.params.orgId }).then((res) => {
      if (res.code == "0000") {
        this.groupList = res.data;
      }
    });
    // 饲料
    getFodderConditions({ orgId: this.params.params.orgId }).then((res) => {
      if (res.code == "0000") {
        this.fodderList = res.data;
      }
    });
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
// 跳转
.title-right {
  display: inline-block;
  position: absolute;
  top: 13px;
  right: 22px;

  span {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #d7d7d9;
  }
}
</style>